enum AgentRole {
	DUAL_AGENT = 'Dual Agent',
	BUYING_AGENT = 'Buying Agent',
	SELLING_AGENT = 'Selling Agent',
}

const formatRoleSelector = (
	userEmail?: string | null,
	sellerAgentEmail?: string,
	buyerAgentEmail?: string
): AgentRole => {
	const userEmailLowerCaseTrimmed = userEmail?.trim().toLowerCase()
	const sellerAgentEmailLowerCaseTrimmed = sellerAgentEmail
		?.trim()
		.toLowerCase()
	const buyerAgentEmailLowerCaseTrimmed = buyerAgentEmail
		?.trim()
		.toLowerCase()

	if (
		sellerAgentEmailLowerCaseTrimmed === userEmailLowerCaseTrimmed &&
		buyerAgentEmailLowerCaseTrimmed === userEmailLowerCaseTrimmed
	) {
		return AgentRole.DUAL_AGENT
	}

	if (buyerAgentEmailLowerCaseTrimmed === userEmailLowerCaseTrimmed) {
		return AgentRole.BUYING_AGENT
	}

	return AgentRole.SELLING_AGENT
}

export { AgentRole }
export default formatRoleSelector
